import { render, staticRenderFns } from "./stepCritica.vue?vue&type=template&id=f51c0ba6"
import script from "./stepCritica.vue?vue&type=script&lang=ts"
export * from "./stepCritica.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports